var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 85,
    viewBox: "0 0 54 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H23.5C40.3447 0 54 13.6553 54 30.5V54.5C54 71.3447 40.3447 85 23.5 85H16C7.16344 85 0 77.8366 0 69V16Z",
    fill: "#E6AB87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26.3871C9 19.5459 14.5459 14 21.3871 14V14C34.4281 14 45 24.5719 45 37.6129V47.3871C45 60.4281 34.4281 71 21.3871 71V71C14.5459 71 9 65.4541 9 58.6129V26.3871Z",
    fill: "#E97A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars4);
export default __webpack_public_path__ + "static/media/ears-4.84cadc6cf7f0a9d7d5e2f7b3c289deac.svg";
export { ForwardRef as ReactComponent };